export default __webpack_public_path__ + "static/media/by.245578c1.svg";